/* eslint-disable */
import { FrameInfo, GifReader } from './GifReader';

export class GifFrames {

    private _frames: Array<GifFrame> = [];

    private _gif: GifReader;

    constructor(_resource: vf.LoaderResource | ArrayBuffer) {
        this._gif = new GifReader('data' in _resource ? _resource.data : _resource);
        let singleTextureWidth: number = this.calcSingleTextureWidth();
        let imageData = document?.createElement('canvas')?.getContext('2d')?.createImageData(this._gif.width, this._gif.height);

        if (isNaN(singleTextureWidth)) {
            for (let i = 0; i < this._gif.numFrames; i++) {
                //得到每帧的信息并将帧延迟信息保存起来
                let gifFrameInfo = this._gif.getFrameInfo(i);
                this._frames.push(new GifFrame(i, this.generateTextureFromGifData(imageData as any, this._gif, i), gifFrameInfo.delay * 10));
            }
        } else {
            let cols: number = Math.floor(singleTextureWidth / (this._gif.width + 1));
            let rows: number = Math.ceil(this._gif.numFrames / cols);
            let gridSize: vf.Point = new vf.Point(this._gif.width + 1, this._gif.height + 1);
            let canvas: HTMLCanvasElement = document.createElement('canvas');
            canvas.width = gridSize.x * cols - 1;
            canvas.height = gridSize.y * rows - 1;

            let ctx = canvas.getContext('2d');
            let lastFrame = undefined;
            for (let i = 0; i < this._gif.numFrames; i++) {
                let col = i % cols;
                let row = Math.floor(i / cols);
                if (lastFrame && lastFrame.disposal == 2) {
                    imageData?.data.fill(0);
                }
                lastFrame = this._gif.decodeAndBlitFrameRGBA(i, imageData?.data as any);
                ctx?.putImageData(imageData as any, col * gridSize.x, row * gridSize.y);
            }

            let spriteSheet = vf.BaseTexture.from(canvas);
            for (let i = 0; i < this._gif.numFrames; i++) {
                let col = i % cols;
                let row = Math.floor(i / cols);
                let gifFrameInfo = this._gif.getFrameInfo(i);
                let texture = new vf.Texture(spriteSheet, new vf.Rectangle(col * gridSize.x, row * gridSize.y, this._gif.width, this._gif.height));
                this._frames.push(new GifFrame(i, texture, gifFrameInfo.delay * 10));
            }
        }
    }

    private calcSingleTextureWidth(): number {
        let sizeList = [1024, 2048, 3072, 4096];
        for (let size of sizeList) {
            let cols: number = Math.floor(size / (this._gif.width + 1));
            let rows: number = Math.floor(size / (this._gif.height + 1));
            if (cols * rows >= this._gif.numFrames) {
                return size;
            }
        }
        return Number.NaN;
    }

    public get gif(): GifReader {
        return this._gif;
    }

    public get frames(): Array<GifFrame> {
        return this._frames;
    }

    private generateTextureFromGifData(imageData: ImageData, gif: GifReader, frame: number): vf.Texture {
        let canvas: HTMLCanvasElement = document.createElement('canvas');
        canvas.width = gif.width;
        canvas.height = gif.height;

        const ctx = canvas.getContext('2d');

        //将第一帧转换为RGBA值，将赋予到图像区
        gif.decodeAndBlitFrameRGBA(frame, imageData.data);

        //将上面创建的图像数据放回到画面上
        ctx?.putImageData(imageData, 0, 0);

        let spriteSheet = vf.BaseTexture.from(canvas);
        return new vf.Texture(spriteSheet, new vf.Rectangle(0, 0, gif.width, gif.height));
    }

    public get numFrames(): number {
        return this._frames.length;
    }

    public getFrame(index: number): GifFrame {
        if (index < 0 || index >= this._frames.length) {
            throw new Error('Gif Frame Index out of range');
        }
        return this._frames[index];
    }
}

export class GifFrame {

    constructor(public index: number, public texture: vf.Texture, public delayTime: number) {

    }
}